import { useEffect, useState, useRef } from 'react';
import io from 'socket.io-client';

export function useWebSocket(
  tenantId: string | undefined,
  onEmailSync?: (data: any) => void,
  onAlertTriggered?: (data: any) => void
) {
  const [socket, setSocket] = useState<any>(null);
  const [prices, setPrices] = useState<any[]>([]);
  const [connected, setConnected] = useState(false);

  // Keep references to changing callbacks stable without triggering restarts
  const onEmailSyncRef = useRef(onEmailSync);
  const onAlertTriggeredRef = useRef(onAlertTriggered);

  useEffect(() => {
    onEmailSyncRef.current = onEmailSync;
    onAlertTriggeredRef.current = onAlertTriggered;
  }, [onEmailSync, onAlertTriggered]);

  useEffect(() => {
    if (!tenantId) {
      return;
    }
    const s = io(process.env.REACT_APP_WS_URL || (typeof window !== 'undefined' ? window.location.origin : ''), {
      query: { tenantId },
    });
    setSocket(s);

    s.on('connect', () => setConnected(true));
    s.on('disconnect', () => setConnected(false));
    s.on('initPrices', (data: any) => {
      if (Array.isArray(data)) setPrices(data);
    });
    s.on('priceUpdate', (data: any) => {
      if (Array.isArray(data)) setPrices(data);
    });
    s.on('emailSyncAlert', (data: any) => {
      if (onEmailSyncRef.current) {
        onEmailSyncRef.current(data);
      }
    });
    s.on('alertTriggered', (data: any) => {
      if (onAlertTriggeredRef.current) {
        onAlertTriggeredRef.current(data);
      }
    });

    return () => {
      s.disconnect();
    };
  }, [tenantId]);

  return { prices, connected };
}


